export enum UserStatusTypeId {
  LEAD = 1,
  ACTIVE = 2,
}
